import { render, staticRenderFns } from "./HeaderControlsRelatedDeliverablesSocial.vue?vue&type=template&id=c9264efa&"
import script from "./HeaderControlsRelatedDeliverablesSocial.vue?vue&type=script&lang=js&"
export * from "./HeaderControlsRelatedDeliverablesSocial.vue?vue&type=script&lang=js&"
import style0 from "./HeaderControlsRelatedDeliverablesSocial.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/uat.cabcom.dashtogo.com/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c9264efa')) {
      api.createRecord('c9264efa', component.options)
    } else {
      api.reload('c9264efa', component.options)
    }
    module.hot.accept("./HeaderControlsRelatedDeliverablesSocial.vue?vue&type=template&id=c9264efa&", function () {
      api.rerender('c9264efa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/common/HeaderControlsRelatedDeliverablesSocial.vue"
export default component.exports